/*
 * Public API Surface of astimax
 */

export * from './astimax.service';
export * from './plugin-initializer';
